import React from 'react'
import Thumbnail from './thumbnail'
import Media from 'react-media';


const ThumbnailGrid = ({thumbnails, handleClick, off}) => {
	return (
    <Media queries={{
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }}>
      {matches => (
        <>
          {/* {matches.small && <p>I am small!</p>}
          {matches.medium && <p>I am medium!</p>}
          {matches.large && <p>I am large!</p>} */}
          <div style={sStyles}>
          {
            thumbnails.map((i, index) => (
              <Thumbnail key={i.id} thumb={i} handleClick={handleClick} off={off} index={index}/>
            ))
          }
          </div>
        </>
      )}

    </Media>
	)
}

const sStyles = {
	paddingUp: '100%',
	display: 'flex',
	flexWrap: 'wrap',
	height: '30vw',
	maxWidth: '15vw'
}

const mStyles = {
	paddingUp: '100%',
	display: 'flex',
	flexWrap: 'wrap',
	height: '30vw',
	maxWidth: '15vw'
}

const lStyles = {
	paddingUp: '100%',
	display: 'flex',
	flexWrap: 'wrap',
	height: '30vw',
	maxWidth: '15vw'
}
export default ThumbnailGrid;